import {Component, Input, OnInit} from '@angular/core';
import {Actions} from "../../../model/actions.model";
import {FormGroup} from "@angular/forms";
import {Destinations} from "../../../model/destinations.model";

@Component({
  selector: 'app-results',
  templateUrl: './results.component.html',
  styleUrls: ['./results.component.css']
})
export class ResultsComponent implements OnInit {
  @Input('inputForm') inputForm: FormGroup;
  @Input('results') results: any;

  actions = Actions;
  destinations = Destinations;

  constructor() { }

  ngOnInit(): void {
  }

}
